/* eslint-disable react/prop-types */
import React from 'react';
import './load3.scss';

export function LoadGif3() {
  return (
    <div className="loader">
      <div className="d1"></div>
      <div className="d2"></div>
    </div>
  );
}
